import { useState } from 'react';
import { actionIcon } from '../../lib/icons.jsx';
import './Modal.css';

const Modal = ({ title, onClose, children, width = 640 }) => (
  <div className="gencrm_modal_overlay" onClick={onClose}>
    <div className="gencrm_modal" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
      <div className="gencrm_modal__header">
        <h3>{title}</h3>
        <button className="gencrm_modal__close" onClick={onClose} aria-label="Fechar">{actionIcon('close', 18)}</button>
      </div>
      <div className="gencrm_modal__body">{children}</div>
    </div>
  </div>
);

export default Modal;
